import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { PageLayout } from '@hero/components/layouts';
import { ProductSelectionSection } from '@hero/components/organisms';
import { useValidationErrorsStore } from '@hero/components/providers/ValidationErrorsProvider';
import { SEND_GIFT_FLOW_STEPS, SEND_GIFT_REDIRECT_STATUSES } from '@hero/constants';
import { ROUTE_PATHS } from '@hero/routes';
import { useGetRecognition, useUpdateRecognition } from '@hero/services';

import WidgetFooter from './WidgetFooter';

export function SendGiftUpdateCollectionTemplate() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { recognitionCode } = useParams();

  const [selectedProducts, setSelectedProducts] = useState([]);

  const { data: recognition } = useGetRecognition(
    {
      recognitionCode
    },
    {
      onSuccess: data => {
        if (SEND_GIFT_REDIRECT_STATUSES.includes(data?.status?.current)) {
          navigate(ROUTE_PATHS.MY_RECOGNITION_DETAIL(data?.code));
        }
      }
    }
  );
  const { mutateAsync: updateRecognition, isLoading } = useUpdateRecognition();

  useEffect(() => {
    if (!selectedProducts.length && recognition?.products?.length) {
      setSelectedProducts(recognition.products);
    }
  }, [recognition?.products]);

  const { addError } = useValidationErrorsStore();

  const handleConfirm = async () => {
    if (!selectedProducts.length) {
      await addError(
        <Trans
          key="noProductAtList"
          i18nKey="errors.noSelectedProduct"
          components={{
            b: <b />
          }}
        />
      );
      return;
    }

    await updateRecognition({
      params: {
        recognitionCode
      },
      body: {
        products: selectedProducts,
        meta: {
          creationStep: SEND_GIFT_FLOW_STEPS.review
        }
      }
    });

    navigate(ROUTE_PATHS.SEND_GIFT_REVIEW(recognitionCode));
  };

  return (
    <PageLayout
      header={{
        title: t('addItemsYourGiftCollection'),
        stepNumber: 1
      }}
      navigation={{
        rightButton: {
          children: t('continueWithSelectedItems'),
          onClick: handleConfirm,
          loading: isLoading
        }
      }}
    >
      <ProductSelectionSection
        localShoppingCartEnabled
        showSaveAsCollectionButton={false}
        selectedProducts={selectedProducts}
        onChangeSelectedProductList={selectedProducts => {
          setSelectedProducts(selectedProducts);
        }}
        onConfirmCart={handleConfirm}
        components={{
          WidgetFooter
        }}
        isDraft
      />
    </PageLayout>
  );
}
